"use client";

import { FlavorFinder as UIFlavorFinder } from "@jti/ui/components/FlavorFinder";

import type { OptionalQuizModelType } from "@/components/FlavorFinder/api";
import type { flavorFinderInputs } from "@/components/FlavorFinder/FlavorFinder.builder";
import { useQuiz } from "@/components/FlavorFinder/useQuiz";

type FlavorFinderBuilderProps = BuilderComponentProps<typeof flavorFinderInputs> & {
  generalTab: {
    sharedFinalQuestion?: {
      id: string;
      value: OptionalQuizModelType | undefined;
    };
  };
};

export const FlavorFinder = ({
  generalTab,
  introSectionTab,
  consentPolicyTab,
  resultsSlideTab,
}: FlavorFinderBuilderProps) => {
  const quizModel = useQuiz(
    generalTab.sharedFinalQuestion?.value,
    resultsSlideTab?.finalActionCtaLink,
    resultsSlideTab?.resultsLinkWithDevice
  );

  return (
    <UIFlavorFinder
      data={{
        ...generalTab!,
        quizQuestionsSubtree: "",
        intro: {
          ...introSectionTab!,
          mediumIntroBackgroundVideo:
            introSectionTab?.mediumIntroBackgroundVideo ?? introSectionTab?.introBackgroundVideo ?? "",
          smallIntroBackgroundVideo:
            introSectionTab?.smallIntroBackgroundVideo ?? introSectionTab?.introBackgroundVideo ?? "",
        },
        quizTransitions: quizModel.quizTransitions,
        finalQuestion: quizModel.finalQuestion,
        result: {
          ...resultsSlideTab!,
          deviceSuggestion: {
            description: resultsSlideTab?.deviceSuggestionDescription ?? "",
            imgUrl: resultsSlideTab?.deviceSuggestionImgUrl ?? "",
            defaultDeviceSuggestionState:
              resultsSlideTab?.deviceSuggestionState === "none" ? "" : (resultsSlideTab?.deviceSuggestionState ?? ""),
          },
        },
        totalNumberOfQuestions: generalTab?.totalNumberOfQuestions ?? 0,
        redoCtaLabel: resultsSlideTab?.redoCtaLabel ?? "",
        consentPolicy: {
          ...consentPolicyTab!,
          disableSendingMailResults: false,
        },
        finalActionCtaLabel: resultsSlideTab?.finalActionCtaLabel ?? "",
        finalActionCtaLink: resultsSlideTab?.finalActionCtaLink ?? "",
        skipAndShowResultsCtaLabel: consentPolicyTab?.skipAndShowResultsCtaLabel ?? "",
        showResultsLabel: consentPolicyTab?.showResultsLabel ?? "",
        questionDimensions: {
          entity: "quiz_question_raw",
          payload: quizModel.questionDimensions,
        },
        answerDimensions: {
          entity: "quiz_answer_raw",
          payload: quizModel.answerDimensions,
        },
      }}
    />
  );
};
